module.exports = __webpack_public_path__ + "img/kona-electric-25.5dc40fc1.png";